import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ANALYTICS_EVENTS, AnalyticsService} from '../services/analytics.service';
import {LicensingComponent} from '../licensing/licensing.component';

@Component({
  selector: 'app-header',
    imports: [
        FormsModule,
        LicensingComponent
    ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  providers:[AnalyticsService]
})
export class HeaderComponent implements OnInit {
    constructor( private analyticsService: AnalyticsService ) {
    }

    ngOnInit() {
        //this.analyticsService.trackEvent( 'Header loaded','','');
    }

    soMeClick( target: string, url: string ) {
        this.analyticsService.track( ANALYTICS_EVENTS['SO_ME_BUTTON_CLICKED'], target );
        window.open( url , '_blank' );
    }
}
